// extracted by mini-css-extract-plugin
module.exports = {"head":"head__4AK6uw644jkpI","section":"section__K476gNB98H87P","inputDescription":"inputDescription__2pCPTatv77D9Z","error":"error__5NEfCOtxne6y-"};